// Vendors
import { useMemo } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Event Handlers
import { BackgroundFooterHandlers } from '../handlers/background-footer.handlers';
import { LogHandlers } from 'handlers/log.handlers';
// Hooks
import { useCallbackBackHook } from 'hooks/callback-back.hook';
// Types
import { BackgroundFooterHookType } from './types/background-footer.hook.type';
import { BackgroundHookType } from 'providers/background/hooks/types/background.hook.type';

const useBackgroundFooterHook = (
  props: Pick<BackgroundHookType, 'setShowBackgroundModal'>
): BackgroundFooterHookType => {
  const { showBoundary: setError } = useErrorBoundary();

  const { handleLogCallbackUrlCallEvent } = useCallbackBackHook();

  const { handleSendCustomActionEvent } = LogHandlers(),
    { handleManageCustomerAgreementButtonClick } = useMemo<
      ReturnType<typeof BackgroundFooterHandlers>
    >(() => BackgroundFooterHandlers({ ...props, handleSendCustomActionEvent, setError }), []);

  return {
    handleLogCallbackUrlCallEvent,
    handleManageCustomerAgreementButtonClick,
  };
};

export { useBackgroundFooterHook };
